<template>
  <div>
    <h3 class="mb-3">
      {{ filterTypeName }}
    </h3>
    <div
      v-for="hierarchyFilter in hierarchyFilters"
      :key="hierarchyFilter.id"
      class="mt-1 align-content-center"
    >
      <FilterHierarchy
        :ref="hierarchyFilter.id"
        :hierarchy="hierarchyFilter"
        :underlined-class="underlinedClass"
        :selected-filters-option-ids="selectedFilters"
        :disabled-filters="disabledFilters"
      />
    </div>
  </div>
</template>

<script>
import FilterHierarchy from '@/app/shared/components/FilterHierarchy'
export default {
  name: 'FiltersSelectorLogic',
  components: {
    FilterHierarchy
  },
  props: {
    selectedFilters: {
      type: Object,
      default: () => { return {} }
    },
    filterTypeName: {
      type: String,
      default: ''
    },
    hierarchyFilters: {
      type: Array,
      default: () => { return [] }
    },
    underlinedClass: {
      type: Boolean,
      default: true
    },
    disabledFilters: {
      type: Array,
      default: () => { return [] }
    }
  },
  methods: {
    buildFilters () {
      let filters = {}
      this.hierarchyFilters.forEach((hierarchyFilter) => {
        filters = { ...filters, ...this.buildHierarchyLevels(this.$refs[hierarchyFilter.id][0].filters) }
      })
      return filters
    },
    buildHierarchyLevels (hierarchyLevel) {
      const filter = {}
      for (const filterId in hierarchyLevel) {
        filter[filterId] = hierarchyLevel[filterId].map((selectedLevelOptions) => selectedLevelOptions.id)
      }
      return filter
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/shared/components/FilterSelectorLogic.vue